import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../../components/landing"
import { soleTraderGuideZh } from "../../content/zh/sole-trader-tax-calculator"
import { guideSeo } from "../guides.$slug"

const PATH = "/sole-trader-tax-calculator"

/** Chinese version of /sole-trader-tax-calculator (D-WEB-LANG-SCOPE, T1321); the English route carries the hreflang pair too. */
export const soleTraderZhSeo = () => guideSeo(soleTraderGuideZh, PATH, "zh")

export const Route = createFileRoute("/_brand-layout/zh/sole-trader-tax-calculator")({
  head: () => {
    const { meta, links, scripts } = soleTraderZhSeo()
    return { meta, links, scripts }
  },
  component: SoleTraderZhPage,
})

export function SoleTraderZhPage() {
  return <GuidePage guide={soleTraderGuideZh} />
}
